import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetSeguimientoDocumento } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SegDocumentosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/seguimiento-documentos`;

  constructor(private readonly http: HttpClient) {}

  getSeguimientoDocumento(seguimientoId: number): Observable<IGetSeguimientoDocumento[]> {
    return this.http.get<IGetSeguimientoDocumento[]>(`${this.apiUrl}/${seguimientoId}`);
  }

  public downloadFormFile(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/descargar/${id}`, { responseType: 'blob' });
  }
}
